import React, {useState} from "react"
import FieldProto from "../../../../../proto/field-proto"
import formatTime from "../../../../../../gd/format/time"
import {FieldViewSize} from "../../../../../const";

type Props = {
    className?  : string

    field       : FieldProto
    value       : Moment

    disabled?   : boolean
    options?    : any

    onClick     : callback      // open dropdown
    onReset?    : callback      // open dropdown

    children    : any
}


export default function FieldTimeOfDay_FormValueNotEmpty(props:Props) {

    const size : FieldViewSize = _.get(props, 'size', FieldViewSize.DEFAULT)

    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    const onDeleteClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        props.onReset && props.onReset()
    }

    const showIcon = _.get(props.options, 'showIcon', true)

    const className = Classes("ui5-field-form-element not-selectable", "size-"+size, props.className, {
        'is-hovered'        : isHovered || props.children
    })

    if (isHovered || props.children) {
        return (
            <React.Fragment>
                <div className={className} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    <div className="flex-row-left-center">
                        {showIcon && <div className="ui5-ico-16 i5-my-time m-r-10"></div>}
                        <div className="ui5-txt-default txt-truncate">{formatTime(props.value)}</div>
                    </div>

                    <div className="buttons">
                        <div className="btn-reset" onClick={onDeleteClick}/>
                        <div className="btn-arrow"/>
                    </div>
                </div>
                {props.children}
            </React.Fragment>
        )
    }

    // not hovered
    return (
        <React.Fragment>

            <div className={Classes(className, "flex-row-between-center")}
                 onClick={props.onClick}
                 onMouseEnter={onMouseEnter}
                 onMouseLeave={onMouseLeave}>
                <div className="flex-row-left-center">
                    {showIcon && <div className="ui5-ico-16 i5-my-time m-r-10"></div>}
                    <div className="ui5-txt-default txt-truncate">{formatTime(props.value)}</div>
                </div>
                <div className="buttons">
                    <div className="btn-arrow"/>
                </div>
            </div>
            {props.children}
        </React.Fragment>
    )

}
